import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { CreditCardSelection } from '../../../../payment-methods/components/credit-card-selection';
import { CreditCardTokenEntity } from '../../../../../../../api/types/students/credit-card-tokens/credit-card-token-entity';

interface SwitchCreditCardDialogProps {
  visible: boolean;
  onHide: () => void;
  creditCardTokens: CreditCardTokenEntity[];
  currentCreditCardTokenId: number | null;
  onConfirm: (creditCardTokenId: number) => Promise<void>;
  onAddNewCard: () => void;
  loading: boolean;
}

export const SwitchCreditCardDialog: React.FC<SwitchCreditCardDialogProps> = ({
  visible,
  onHide,
  creditCardTokens,
  currentCreditCardTokenId,
  onConfirm,
  onAddNewCard,
  loading,
}) => {
  const [selectedCreditCardTokenId, setSelectedCreditCardTokenId] = useState<
    number | null
  >(null);

  // Reset selection when dialog opens
  useEffect(() => {
    if (visible) {
      setSelectedCreditCardTokenId(currentCreditCardTokenId);
    }
  }, [visible, currentCreditCardTokenId]);

  const handleConfirm = async () => {
    if (selectedCreditCardTokenId) {
      await onConfirm(selectedCreditCardTokenId);
    }
  };

  const canConfirm =
    selectedCreditCardTokenId !== null &&
    selectedCreditCardTokenId !== currentCreditCardTokenId;

  return (
    <Dialog
      header="החלפת כרטיס אשראי"
      visible={visible}
      onHide={onHide}
      /*style={{ width: '550px' }}*/
      footer={
        <div
          style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}
        >
          <Button
            label="ביטול"
            icon="pi pi-times"
            severity="secondary"
            onClick={onHide}
            disabled={loading}
          />
          <Button
            label="עדכן כרטיס"
            icon="pi pi-check"
            onClick={handleConfirm}
            loading={loading}
            disabled={!canConfirm}
          />
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px',
            backgroundColor: '#EEF2FF',
            borderRadius: '8px',
            border: '1px solid #C7D2FE',
          }}
        >
          <i
            className="pi pi-info-circle"
            style={{ fontSize: '24px', color: '#6366F1' }}
          />
          <div>
            <div style={{ fontWeight: 'bold', color: '#4338CA' }}>
              החלפת כרטיס אשראי להוראת קבע
            </div>
            <div
              style={{ color: '#6366F1', marginTop: '4px', fontSize: '14px' }}
            >
              בחר כרטיס אשראי חדש לחיוב התשלומים הבאים
            </div>
          </div>
        </div>

        <CreditCardSelection
          creditCardTokens={creditCardTokens}
          selectedCreditCardTokenId={selectedCreditCardTokenId}
          onCreditCardChange={setSelectedCreditCardTokenId}
          onAddNewCardClick={onAddNewCard}
        />
      </div>
    </Dialog>
  );
};
